import { FunctionComponent } from 'react';
import { useRouter } from 'next/router';
import classnames from 'classnames';

// context
import { useViewDetected } from '@Components/Utils/ViewDetected';

// api
import { getCountAlphabet } from '@Libs/api/cms/disease';

// styles
import styles from './Alphabet.module.scss';
import Anchor from '@Components/Utils/Anchor';

interface AlphabetProps {
    className?: string;
}

const Alphabet: FunctionComponent<AlphabetProps> = ({ className }) => {
    const { deviceType } = useViewDetected();
    const router = useRouter();

    const alphabetParams = router.query.alphabet || '';

    const { data: alphabets = {} } = getCountAlphabet();

    const renderAlphabet = () => {
        return Object.keys(alphabets).map((alphabet, index) => {
            const alphabetClassName = classnames([styles.alphabet, { [styles.hasValue]: alphabets[alphabet] === 0, [styles.active]: alphabet === alphabetParams.toString().toUpperCase() }]);
            return (
                <div key={`alphabet-${alphabets[alphabet]}-${index}`} className={styles.alphabet_wrapper}>
                    <Anchor href={`/tra-cuu/benh?alphabet=${alphabet.toLowerCase()}`} className={alphabetClassName}>{alphabet}</Anchor>
                </div>
            );
        });
    };

    const wrapperClassName = classnames([
        styles.wrapper,
        {
            [styles.mobile]: ['mobile', 'tablet'].includes(deviceType),
        },
        className,
    ]);

    return (
        <div className={wrapperClassName}>
            <div className={classnames([styles.alphabet_wrapper])}>
                <Anchor href={'/tra-cuu/benh'} className={styles.alphabet}>
                    Tất cả
                </Anchor>
            </div>
            {renderAlphabet()}
        </div>
    );
};

Alphabet.defaultProps = {
    className: '',
};

export default Alphabet;
